<template>
  <div class="company-header">
    <div v-if="showBack" class="company-header--back">
      <BackButton @click="clickBack" />
    </div>

    <div class="company-header--logo">
      <a v-if="companyUrl" :href="companyUrl" target="_blank">
        <img
          alt="Inspection Company Logo"
          :src="companyLogo"
          class="company-header--logo-img" />
      </a>
      <img
        v-else
        alt="Inspection Company Logo"
        :src="companyLogo"
        class="company-header--logo-img" />
    </div>
    <div class="hidden-screen-only">
      <h1 class="company-header--name">
        {{companyName}}
      </h1>
    </div>
  </div>
</template>

<script>
import BackButton from '@/components/common/BackButton.vue';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    BackButton,
  },
  props: {
    companyLogo: {
      type: String,
      required: true,
    },
    companyName: {
      type: String,
      default: 'Inspection Company',
    },
    companyUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    showBack() {
      const currentStepIndex = StepUtilities.getStepIndexByRouteName(this.$route.name);
      return currentStepIndex > 0
        && currentStepIndex < (StepUtilities.stepOrder.length - 1);
    },
  },
  methods: {
    clickBack() {
      StepUtilities.goToPreviousStep(this.$route, this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins/breakpoints';
@import '../styles/mixins/images';
@import '../styles/vars/header';
@import '../styles/vars/theme';

.company-header {
  background: $theme-color-white;
  border-bottom: $header-bar-size solid $header-bar-color;
  height: 98px;
  position: relative;

  &--back {
    display: none;
  }

  &--logo {
    background: $theme-color-white;
    height: $header-logo-size;
    padding: 1rem;
    position: relative;
    text-align: center;
    width: $header-logo-size * 1.655;
    z-index: 2;

    &-img {
      @include image-contained;
    }
  }
}

@include responsive-breakpoint(sm) {
  .company-header {
    height: auto;
    padding: 12px 0;
    text-align: center;

    &--back {
      display: block;
      left: 5px;
      position: absolute;
      top: 18px;
    }

    &--logo {
      display: inline-block;
      height: $header-logo-size-mobile;
      padding: 0;
      width: $header-logo-size-mobile * 2;
    }
  }
}

@include responsive-breakpoint(print) {
  .company-header {
    border: none;
    padding: 5px 0;
    text-align: center;

    &--logo {
      width: 100%;
    }

    &--name {
      font-size: 2rem;
    }
  }
}
</style>
